const initState = () => {
  return [];
}

const clients = (state=initState(), action) => {
  switch (action.type) {

    case "INIT_CLIENTS":
      const clients = action.payload.map(i => {return {
        ...i,
        // ...{country: i.address.country ? i.address.country : ''},
        ...{avatar: `${i.avatar}?${new Date().getTime()}`}
      }});
      return clients;

    default:
      return state;
  }
}

export default clients;
